<mat-dialog-content>
  <div class="dialog-content">
    <h2>Schedule of temporary {{ handoffType }} outages:</h2>
    <p>To remove a scheduled outage, select it from this list.</p>

    <div class="close-modal" (click)="onNoClick()">X</div>

    <div class="scroll-list">
      @for (plannedHandoffException of plannedHandoffExceptions; track plannedHandoffException; let i = $index) {
        <div (click)="setSelectedRow(i)" class="exception-container" [ngClass]="{ highlight: selectedIndex === i }">
          <div class="exception-row">
            <h3 class="exception-date light-bold">
              {{ formattedExceptionDate(plannedHandoffException) }}
            </h3>
          </div>
          @if (selectedIndex === i) {
            <div>
              @if (canMakeChanges()) {
                <div class="button-container">
                  <button mat-raised-button color="accent" (click)="editAction(plannedHandoffException)">Edit</button>
                  <button mat-raised-button color="warn" (click)="deleteOverrideConfirm(plannedHandoffException)">
                    Remove
                  </button>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
    <p class="light-gray-text">{{ plannedHandoffExceptions.length }} Scheduled</p>
  </div>
</mat-dialog-content>
